module.exports = __webpack_public_path__ + "static/img/staff2.a8a4352a.svg";